export default __webpack_public_path__ + "c13d7384988296df26976a6b9b69b9c0.svg";